import { useMemo } from 'react';
import { useChegadas } from './useChegadas';

export function useChegadaByCodigoAndDate(codigo, data) {

    const chegadas = useChegadas(codigo);

    return useMemo(() => {

        if (!codigo || !data) {
            return null;
        }

        return (
            chegadas.find(c => {

                if (data < c.inicio) {
                    return false;
                }

                if (c.fim && data > c.fim) {
                    return false;
                }

                return true;

            }) ?? null
        );

    }, [chegadas, codigo, data]);

}